export default import.meta.ROLLUP_FILE_URL_Ci55WTQw;